import { getSubgraphConfig, SubgraphConfigEntry, SubgraphType } from 'config/subgraph'

import { useConnection } from './useConnection'

export const useSubgraphConfig = (subgraphType: SubgraphType): SubgraphConfigEntry => {
  const { chainId } = useConnection()
  return getSubgraphConfig(chainId, subgraphType)
}
